// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"582":"bea8b1d3","594":"b4b672cb"}[chunkId] + ".chunk.css";
};